export default __webpack_public_path__ + "static/assets/9296a3c3546e0754010a9c829d11c76d.svg";